module.exports = "<!-- <ngx-loading [show]=\"!isLoggedIn\"></ngx-loading> -->\r\n<div class=\"\">\r\n    <app-header> </app-header>\r\n    <section class=\"container\">\r\n        <div class=\"row flex-nowrap\">\r\n            <app-side-bar></app-side-bar>\r\n            <div class=\"col right-col\">\r\n                <router-outlet></router-outlet>\r\n            </div>\r\n        </div>        \r\n    </section>\r\n</div>\r\n<app-logger></app-logger>"


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/Fed/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main